import ProfileInfoRow from "./ProfileInfoRow";
import icons from "../../lib/icons";
import EmailUpdateModalBtn from "./EmailUpdateModalBtn";
import Logout from "../../shared/Logout";

const PersonalInformationSection = ({ data }) => {
  return (
    <div className="space-y-2">
      <ProfileInfoRow
        label="نام و نام‌خانوادگی"
        value={`${data.first_name_fa} ${data.last_name_fa}`}
        actions={<Logout />}
      />
      <ProfileInfoRow
        label="شماره همراه"
        value={data.phone}
        actions={
          <button className="btn-edit flex items-center gap-1 opacity-0">
            <p>ویرایش </p>
            <img src={icons.edit} alt="" width={16} height={16} />
          </button>
        }
      />
      <ProfileInfoRow
        label="ایمیل "
        value={data.email}
        actions={<EmailUpdateModalBtn userEmail={data.email} />}
      />
      <ProfileInfoRow
        label="کدملی "
        value={data.national_code}
        actions={
          <button className="btn-edit flex items-center gap-1">
            <p>{data.national_code ? "تاییدشده" : "وارد نشده است"}</p>
            {data.national_code && (
              <img src={icons.checked} alt="" width={16} height={16} />
            )}
          </button>
        }
      />
    </div>
  );
};

export default PersonalInformationSection;
